import type { Theme } from "@mui/material";
import { ICON_TILE } from "@/theme/tokens";

/**
 * The name starts where the group's title does — past the header's round icon and its gap — so a group reads as one
 * column of text. The row itself is inset by the header's own padding, so its divider starts under the icon.
 */
export const TEXT_INSET = (theme: Theme): string => `calc(${ICON_TILE.XS.size}px + ${theme.spacing(1.5)})`;

export const ONE_LINE = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } as const;
